import React from 'react'
import { ButtonLinkSmall } from '../components/buttons'

import bubbleLogo from '../images/bubble-logo-2.svg'
import outdoorIcon from '../images/icons/icon--outdoor.svg'
import dayIcon from '../images/icons/icon--day.svg'
import clockIcon from '../images/icons/icon--clock.svg'
import calendarIcon from '../images/icons/icon--calendar.svg'

export const ActivityFeed = () => {
  const activityData = [
    {
      activity: 'Home with repair man',
      activityType: 'Outdoor Hang',
      duration: '1 hr 15 min',
      date: 'March 2, 2021',
    },
    {
      activity: 'Home with repair man',
      activityType: 'Outdoor Hang',
      duration: '1 hr 15 min',
      date: 'March 2, 2021',
    },
    {
      activity: 'Home with repair man',
      activityType: 'Outdoor Hang',
      duration: '1 hr 15 min',
      date: 'March 2, 2021',
    },
    {
      activity: 'Home with repair man',
      activityType: 'Outdoor Hang',
      duration: '1 hr 15 min',
      date: 'March 2, 2021',
    },
    {
      activity: 'Home with repair man',
      activityType: 'Outdoor Hang',
      duration: '1 hr 15 min',
      date: 'March 2, 2021',
    },
  ]

  return (
    <>
      <section className="bg-purple-light bg-opacity-25 border-b-1 border-gray-200 relative overflow-hidden">
        <div className="container-lg flex items-center py-16">
          <div>
            <h2 className="font-normal text-purple-dark mb-20">
              My Recent Activity
            </h2>
            <ButtonLinkSmall
              to="#TODO"
              className="bg-purple-light text-white rounded-10"
            >
              Add New Activity
            </ButtonLinkSmall>
          </div>
        </div>
        <img
          className="pointer-events-none absolute -top-3/4 -right-24 opacity-50"
          src={bubbleLogo}
          alt=""
        />
      </section>
      <section className="container-lg my-40">
        {activityData.map((obj, i) => {
          return (
            <div
              key={i}
              className="flex items-center justify-between p-24 mb-12 border-1 border-gray-200 rounded-10 bg-white shadow-100"
            >
              <div className="flex items-center">
                <img
                  className="w-56 h-56 object-none gradient-purple-light border-1 border-purple-light rounded-full"
                  src={outdoorIcon}
                  alt=""
                />
                <div className="text-gray-300 text-16 ml-32">
                  <p className="text-purple-dark text-18 pb-8">
                    {obj.activity}
                  </p>
                  <p className="pb-8 flex items-center">
                    <img className="mr-16" src={dayIcon} alt="" />
                    <span>{obj.activityType}</span>
                  </p>
                  <p className="pb-8 flex items-center">
                    <img className="mr-16" src={clockIcon} alt="" />
                    <span>{obj.duration}</span>
                  </p>
                  <p className="pb-8 flex items-center">
                    <img className="mr-16" src={calendarIcon} alt="" />
                    <span>{obj.date}</span>
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </section>
    </>
  )
}
